import React from 'react'

function CashDom() {
  return (
    <div>CashDom</div>
  )
}

export default CashDom